export function getUserProfileBrowserTabEntityName(userData) {
  return userData?.fullname
}
